<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="类别名称">
              <a-input placeholder="输入类别名称搜索" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="tableSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetTableSearch">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
      <a-button type="default" icon="reload" @click="reloadTable">刷新</a-button>
    </div>

    <s-table
      size="default"
      ref="table"
      :pageSize=20
      :columns="columns"
      :data="loadData"
      bordered
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-popconfirm placement="topLeft" title="确定要删除此类别吗?删除后无法恢复！" @confirm="deleteConfirm(record.id)" okText="确定" cancelText="取消">
                <a href="#">删除</a>
              </a-popconfirm>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <a-modal
      :title="title"
      style="top: 20px;"
      :width="800"
      v-model="visible"
      @ok="editFormSubmit($event,selectrow)"
    >
      <a-form :form="form">

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="上级分类"
        >
          <a-tree-select
            v-model="selectrow.parentId"
            placeholder='请选择上级分类'
            treeDefaultExpandAll
            :treeData="categoryData"
          >
          </a-tree-select>
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="类别名称"
        >
          <a-input
            placeholder="类别名称"
            v-model="selectrow.name"
            autocomplete="false"
          />
        </a-form-item>

      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import { getCategoryGoods, editCategoryGoods, addCategoryGoods, deleteCategoryGoods } from '@/api/category'
import { CODE_FAIL } from '@/store/mutation-types'

export default {
  name: 'SettingsCategoryGoods',
  components: {
    STable
  },
  data () {
    return {
      categoryData: null,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      form: null,
      isEditForm: false,
      title: '新增',
      selectrow: {},

      // 查询参数
      queryParam: {
        name: ''
      },
      // 表头
      columns: [
        {
          title: '类别',
          dataIndex: 'name'
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getCategoryGoods(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.result
          })
      },

      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
    this.loadCategory()
  },
  methods: {
    loadCategory () {
      getCategoryGoods({ tree: true })
        .then(res => {
          this.categoryData = res.result
        })
    },
    handleEdit (record) {
      this.selectrow = Object.assign({}, record)
      this.title = '编辑'
      this.isEditForm = true
      this.visible = true
    },
    handleAdd () {
      this.selectrow = {
        parentId: '',
        name: ''
      }
      this.title = '新增'
      this.isEditForm = false
      this.visible = true
    },
    // 修改表单提交
    editFormSubmit (e) {
      e.preventDefault()
      const data = this.selectrow
      if (this.isEditForm) {
        editCategoryGoods(data).then(res => {
          if (res.status !== CODE_FAIL) {
            this.visible = false
            this.$message.success('修改成功')
            this.loadCategory()
            this.reloadTable()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        addCategoryGoods(data).then(res => {
          if (res.status !== CODE_FAIL) {
            this.visible = false
            this.$message.success('新增成功')
            this.loadCategory()
            this.reloadTable()
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    reloadTable () {
      this.$refs.table.refresh(true)
    },
    tableSearch () {
      this.$refs.table.refresh(true)
    },
    resetTableSearch () {
      this.queryParam = {
        name: ''
      }
      this.reloadTable()
    },
    deleteConfirm (id) {
      deleteCategoryGoods({ id: id }).then((res) => {
        if (res.status !== CODE_FAIL) {
          this.$message.success('删除成功')
          this.loadCategory()
          this.reloadTable()
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },
  watch: {}
}
</script>
